import { MAX_QUEUE_SIZE } from "@/constants";
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { Prompt } from "./types";

type PromptStore = {
  prompts: Prompt[];
  setPrompts: (prompts: Prompt[]) => void;
  addToPrompts: (prompt: Prompt) => void;
  removeFromPrompts: (promptId: Prompt["id"]) => void;
  isAtQueueLimit: boolean;
};

export const useQueuedPromptsStore = create<PromptStore>()(
  devtools((set) => ({
    prompts: [],
    isAtQueueLimit: false,
    setPrompts: (prompts) =>
      set({
        prompts,
        isAtQueueLimit: prompts.length >= MAX_QUEUE_SIZE,
      }),
    addToPrompts: (prompt) =>
      set((state) => {
        const newPrompts = state.prompts.concat(prompt);
        return {
          prompts: newPrompts,
          isAtQueueLimit: newPrompts.length >= MAX_QUEUE_SIZE,
        };
      }),
    removeFromPrompts: (promptId) =>
      set((state) => {
        const newPrompts = state.prompts.filter(({ id }) => id !== promptId);
        return {
          prompts: newPrompts,
          isAtQueueLimit: newPrompts.length >= MAX_QUEUE_SIZE,
        };
      }),
  })),
);
